
import { computed, defineComponent } from '@nuxtjs/composition-api'
import { replaceLinks } from '~/assets/ts/DynamicLinks'

interface Promotion {
  name: string
  start: string
  end: string
  text: string
  link: string
  linkExternal: string
  backgroundColorClass: string
  textColorClass: string
  show: boolean
}

export default defineComponent({
  setup() {
    /*
      Wird angezeigt nach den Parametern
      - Name
      - Start (2021-01-01 00:00:00)
      - Ende (2021-12-31 23:59:59)
      - Text
      - Link
      - LinkExternal
      - Show (true/false)
    */

    const country: string = process.env.NUXT_ENV_DEFAULT_CODE || 'de'

    const promotionList: Array<Promotion> = [
        {
        name: 'fallCampaign', // International: Herbstaktion 10% Rabatt
        start: '2025-08-29 00:00:00',
        end: '2025-10-13 23:59:59',
        text: 'promotion.campaigns.fallCampaign',
        link: 'weddingRings',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-bg',
        textColorClass: 'text-white',
        show: false,
      },
      {
        name: 'fallCampaignDACH', // DE, AT, CH - Reduzierte Preise
        start: '2025-08-29 00:00:00',
        end: '2025-10-13 23:59:59',
        text: 'promotion.campaigns.fallCampaignDACH',
        link: 'weddingRings',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-bg',
        textColorClass: 'text-white',
        show: false,
      },
      {
        name: 'closed', // Shop geschlossen for Roskilde DK
        start: '2024-09-01 00:00:00',
        end: '2025-12-31 23:59:59',
        text: 'promotion.closed',
        link: '',
        linkExternal: 'https://www.acredo-trauringe.de/standorte/kiel/',
        backgroundColorClass: 'bg-brand-promo-bg',
        textColorClass: 'text-white',
        show: false,
      },
      /*
      {
        name: 'platinum', // Stärken Platin
        start: '2025-05-01 00:00:00',
        end: '2025-05-31 23:59:59',
        text: 'promotion.focuses.platinum',
        link: '',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-bannerBlue',
        textColorClass: 'text-white',
        show: false,
      },
      {
        name: 'platinumDACH', // Stärken Platin DACH
        start: '2025-05-15 00:00:00',
        end: '2025-06-16 23:59:59',
        text: '',
        link: '',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-bannerBlue',
        textColorClass: 'text-white',
        show: false,
      },
      {
        name: 'beginningOfTheYear', // Aktion Jahresanfang
        start: '2024-12-25 00:00:00',
        end: '2025-02-24 23:59:59',
        text: 'promotion.campaigns.beginningOfTheYear',
        link: 'weddingRings',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-bg',
        textColorClass: 'text-white',
        show: false,
      },
      {
        name: 'beginningOfTheYearDACH', // Aktion Jahresanfang
        start: '2024-12-25 00:00:00',
        end: '2025-03-10 23:59:59',
        text: 'promotion.campaigns.beginningOfTheYear',
        link: 'weddingRings',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-bg',
        textColorClass: 'text-white',
        show: false,
      },
      {
        name: 'christmas', // Anlässe Weihnachten
        start: '2024-11-23 00:00:00',
        end: '2024-12-24 23:59:59',
        text: 'promotion.festiveOccasions.christmas',
        link: 'diamondJewelryPresentsChristmas',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-bannerdarkPeachFuzz',
        textColorClass: 'text-white',
        show: false,
      },
      {
        name: 'fallCampaign', // Aktion Herbstaktion 10% Rabatt
        start: '2024-08-27 00:00:00',
        end: '2024-09-30 23:59:59',
        text: 'promotion.campaigns.fallCampaign',
        link: 'weddingRings',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-bg',
        textColorClass: 'text-white',
        show: false,
      },
      {
        name: 'summer', // Summer
        start: '2024-08-01 00:00:00',
        end: '2024-08-31 23:59:59',
        text: 'promotion.campaign.summer',
        link: '',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-bg',
        textColorClass: 'text-white',
        show: false,
      },
      {
        name: 'appointment', // Termin vereinbaren
        start: '2024-02-08 00:00:00',
        end: '2024-04-30 23:59:59',
        text: 'promotion.appointment',
        link: '',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-bg',
        textColorClass: 'text-white',
        show: false,
      },
      {
        name: 'engagement', // Verlobungsringe November/Dezember 2023
        start: '2023-11-01 00:00:00',
        end: '2023-12-24 23:59:59',
        text: 'promotion.focuses.engagement',
        link: 'engagementRings',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-banner',
        textColorClass: 'text-white',
        show: false,
      },
        {
        name: 'christmas', // Anlässe Weihnachten
        start: '2023-12-01 00:00:00',
        end: '2022-12-23 23:59:59',
        text: 'promotion.festiveOccasions.christmas',
        link: 'diamondJewelryPresentsChristmas',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-bannerBeige',
        textColorClass: 'text-white',
        show: false,
      },
      {
        name: 'colors', // Stärken Farben (August 2023)
        start: '2023-08-01 00:00:00',
        end: '2023-08-24 23:59:59',
        text: 'promotion.focuses.colors',
        link: '',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-bannerBeige',
        textColorClass: 'text-white',
        show: false,
      },
      {
        name: 'engagementRingsNaturalBeige', // Stärken Diamanten
        start: '2023-06-01 00:00:00',
        end: '2023-07-31 23:59:59',
        text: 'promotion.engagement.NaturalBeige',
        link: '',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-blue',
        textColorClass: 'text-white',
        show: false,
      },
      {
        name: 'engagementRingsNaturalBeigeDK', // Stärken Diamanten
        start: '2023-06-01 00:00:00',
        end: '2023-07-31 23:59:59',
        text: 'promotion.engagement.NaturalBeige',
        link: '',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-banner',
        textColorClass: 'text-white',
        show: false,
      },
      {
        name: 'birthday', // Termin vereinbaren
        start: '2023-02-14 00:00:00',
        end: '2023-02-28 23:59:59',
        text: 'promotion.birthday',
        link: 'memoireRings',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-bannerBlue',
        textColorClass: 'text-white',
        show: false,
      },
      {
        name: 'valentine', // Anlässe Valentingstag
        start: '2022-02-01 00:00:00',
        end: '2022-02-13 23:59:59',
        text: 'promotion.festiveOccasions.valentinesDay',
        link: 'diamondJewelryPresentsValentine',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-banner',
        textColorClass: 'text-white',
        show: false,
      },
      {
        name: 'eternity', // Stärken Memoires
        start: '2022-03-31 00:00:00',
        end: '2022-03-31 23:59:59',
        text: 'promotion.focuses.eternity',
        link: 'memoireRings',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-banner',
        textColorClass: 'text-white',
        show: false,
      },
      {
        name: 'diamonds', // Stärken Diamanten
        start: '2023-06-01 00:00:00',
        end: '2023-06-30 23:59:59',
        text: 'promotion.focuses.diamonds',
        link: '',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-bannerBeige',
        textColorClass: 'text-white',
        show: false,
      },
      {
        name: 'signatureGold', // Stärken Signature Gold
        start: '2022-05-01 00:00:00',
        end: '2022-05-31 23:59:59',
        text: 'promotion.focuses.signatureGold',
        link: '',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-banner',
        textColorClass: 'text-white',
        show: false,
      },
      {
        name: 'secretHeart', // Stärken Secret Heart
        start: '2022-06-01 00:00:00',
        end: '2022-06-30 23:59:59',
        text: 'promotion.focuses.secretHeart',
        link: 'weddingRingsSecretHeart',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-banner',
        textColorClass: 'text-white',
        show: false,
      },
      {
        name: 'engagementRingsPart1', // Stärken Verlobungsringe Teil 1
        start: '2022-07-01 00:00:00',
        end: '2022-07-31 23:59:59',
        text: 'promotion.focuses.engagement',
        link: 'engagementRings',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-banner',
        textColorClass: 'text-white',
        show: false,
      },
      {
        name: 'christmas', // Anlässe Weihnachten
        start: '2022-11-17 23:00:00',
        end: '2022-12-23 23:59:59',
        text: 'promotion.festiveOccasions.christmas',
        link: 'diamondJewelryPresentsChristmas',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-bannerDarkred',
        textColorClass: 'text-white',
        show: false,
      },
      {
        name: 'engagementRingsPart2', // Stärken Verlobungsringe Teil 2
        start: '2022-12-26 00:00:00',
        end: '2022-12-31 23:59:59',
        text: 'promotion.focuses.engagement',
        link: 'engagementRings',
        linkExternal: '',
        backgroundColorClass: 'bg-brand-promo-banner',
        textColorClass: 'text-white',
        show: false,
      },
      */
    ]

    const activePromotion = computed(() => {
      for (const key in promotionList) {
        // Beginning of the year promotion International
        if (
          promotionList[key].name === 'fallCampaign' &&
          [
            'beFr',
            'cn',
            'cz',
            'ee',
            'es',
            'hk',
            'no',
            'sg',
            'tw',
            'us',
          ].includes(country) &&
          promotionList[key].start <= new Date().toISOString() &&
          promotionList[key].end >= new Date().toISOString()
        ) {
          promotionList[key].show = true
          return promotionList[key]
        } else if (
          promotionList[key].name === 'fallCampaignDACH' &&
          ['at', 'ch', 'de'].includes(country) &&
          promotionList[key].start <= new Date().toISOString() &&
          promotionList[key].end >= new Date().toISOString()
        ) {
          promotionList[key].show = true
          return promotionList[key]
        } else if (
          promotionList[key].name === 'closed' &&
          ['dk'].includes(country)
        ) {
          promotionList[key].show = true
          return promotionList[key]
        } else {
          promotionList[key].show = false
        }
      }

      return {
        name: '',
        start: '',
        end: '',
        backgroundColorClass: '',
        textColorClass: '',
        show: false,
        link: '/',
        linkExternal: '',
        text: '',
      }
    })

    return {
      activePromotion,
      replaceLinks,
    }
  },
})
